window.appConfig = {
  votingBanner: 1619288423000 < new Date().getTime(),
  voting: true,
  makerPropsalId: 0,
  compoundPropsalId: 0,
  voteBpApi: "https://eth-node.b-protocol.workers.dev"//"http://localhost:8545"
}